import { MessageResponseDto } from "@api/api";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { vehicleFormDefault } from "@factory/form/form.default";
import { VehicleFormRule, VehicleFormSchema } from "@factory/form/form.rule";
import { useQyCreateVehicle } from "@factory/query/vehicle.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

export function useNewVehicle() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateVehicle } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();
  const {personId} = useParams()

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Vehicle is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addVehicle, isLoading: isCreating } =
    useQyCreateVehicle(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<VehicleFormSchema>({
    defaultValues: vehicleFormDefault,
    resolver: zodResolver(VehicleFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: VehicleFormSchema) => {
    form.userCode = personId;
    const formData = mapCreateVehicle(form);
    addVehicle(formData);
  };
  const handleValidateError = (err: FieldErrors<VehicleFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
